import { MyTaskCommonState } from '@/types/MyTask'
import { defineStore } from 'pinia'

export const useMyTaskCommonStore = defineStore('MyTaskCommon', {
  state: (): MyTaskCommonState => {
    return {
      tab: null,
      targetId: null,
    }
  },
  actions: {
    async setTargetId(id: number | null) {
      this.targetId = id
    },
    async setTab(tabName: string | null) {
      this.tab = tabName
    },
    async clear() {
      this.targetId = null
      this.tab = null
    }
  },
  getters: {
    id(state): number | null {
      return state.targetId
    },
    tabName(state): string | null {
      return state.tab
    },
  }
})
